import { Observable } from 'rxjs';
import { SendEmailStatusEnum, UserModel, VatStatusEnum } from '../../../models';

export interface DocumentsModule {
  user?: UserModel;
  disabled?: boolean;
  statusLineInverse?: boolean;
  reverseDirection?: boolean;
  hideProgress?: boolean;
  dateFormat?: string;
  runpleId?: string;
  rightLabel?: string;
  dueWithinDays?: any;
  postfix?: any;
  isEndless?: any;
  maxValue?: any;
  value?: any;
  label?: string;
  status?: string;
  documentRunpleId?: string;
  icon?: string;
  routerLink?: string;
  title?: string;
  type?: DocumentTypeEnum;
  vatStatus?: VatStatusEnum;
  emailSentStatus?: SendEmailStatusEnum;
  statusLineType?: string;
  statusLineOverdueHighlight?: boolean;
  hintId?: string;
  expectedDate?: any;
  colorState?: string;
  currency?: string;
  action?: string;
  valueOnly?: boolean;
  steps?: any[];
  hide?: boolean;
  loading$?: Observable<any>;
  id?: number;
}

export enum DocumentTypeEnum {
  linkDocument,
  StatusLine,
  Steps
}

export enum StepStatusEnum {
  Pending = 'pending',
  In_progress = 'in-progress',
  Success = 'success',
  Canceled = 'canceled',
  Deleted = 'deleted',
}

export interface HelperActionModel {
  icon?: string;
  actionIcon?: string;
  title: string;
  action: string;
  disabled?: boolean;
  hide?: boolean;
  showCondition?: boolean;
}


